module.exports = __webpack_public_path__ + "assets_1789460829583/img/guide_ios.431fc979.png";